import React, { PureComponent } from 'react';

/**
 * since we're using HOC reference, it can't be stateless
 * **/
// eslint-disable-next-line react/prefer-stateless-function
class Wrapper extends PureComponent {
    render() {
        const { children, className } = this.props;
        return <span className={className}>{children}</span>;
    }
}

export default Wrapper;
